module.exports = __webpack_public_path__ + "static/img/avatar.7dd0dde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/profile/avatar.png
// module id = dXZa
// module chunks = 1